import { reportsBehindOrdersConstants } from "_constants";

const initialState = {
  loading: 0,
  posting: false,
  deleting: false,
  behindOrders: [],
  behindOrderRules: [],
};

export function reportsBehindOrders(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case reportsBehindOrdersConstants.GET_REPORTS_BEHIND_ORDERS_REQUEST:
      return { ...state, loading: state.loading + 1, behindOrders: [] };

    case reportsBehindOrdersConstants.GET_REPORTS_BEHIND_ORDERS_SUCCESS:
      return { ...state, loading: state.loading && state.loading - 1, behindOrders: payload };

    case reportsBehindOrdersConstants.GET_REPORTS_BEHIND_ORDERS_FAILURE:
      return { ...state, loading: state.loading && state.loading - 1, behindOrders: [] };

    case reportsBehindOrdersConstants.GET_REPORTS_BEHIND_ORDER_RULES_REQUEST:
      return { ...state, loading: state.loading + 1, behindOrderRules: [] };

    case reportsBehindOrdersConstants.GET_REPORTS_BEHIND_ORDER_RULES_SUCCESS:
      return { ...state, loading: state.loading && state.loading - 1, behindOrderRules: payload };

    case reportsBehindOrdersConstants.GET_REPORTS_BEHIND_ORDER_RULES_FAILURE:
      return { ...state, loading: state.loading && state.loading - 1, behindOrderRules: [] };

    case reportsBehindOrdersConstants.POST_REPORTS_BEHIND_ORDER_RULES_REQUEST:
      return { ...state, posting: true };

    case reportsBehindOrdersConstants.POST_REPORTS_BEHIND_ORDER_RULES_SUCCESS:
      return { ...state, posting: false };

    case reportsBehindOrdersConstants.POST_REPORTS_BEHIND_ORDER_RULES_FAILURE:
      return { ...state, posting: false };

    case reportsBehindOrdersConstants.DELETE_REPORTS_BEHIND_ORDER_RULES_REQUEST:
      return { ...state, deleting: true };

    case reportsBehindOrdersConstants.DELETE_REPORTS_BEHIND_ORDER_RULES_SUCCESS:
      return { ...state, deleting: false };

    case reportsBehindOrdersConstants.DELETE_REPORTS_BEHIND_ORDER_RULES_FAILURE:
      return { ...state, deleting: false };

    default:
      return state;
  }
}
